export class RegistrationModel {
    userId: string;
    orgName: string;
    userFirstName: string;
    userLastName: string;
    contactNumber: string;
    password: string;
    constructor(data: any = {}) {
        this.userId = (data.userId) ? data.userId : this.userId;
        this.orgName = (data.orgName) ? data.orgName : this.orgName;
        this.userFirstName = (data.userFirstName) ? data.userFirstName : this.userFirstName;
        this.userLastName = (data.userLastName) ? data.userLastName : this.userLastName;
        this.contactNumber = (data.contactNumber) ? data.contactNumber : this.contactNumber;
        this.password = (data.password) ? data.password : this.password;
    }
}

